import type { SVGProps } from 'react';

import logoUrl from './logo_wai_01.svg?url';

export function LogoWai(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <image href={logoUrl} width="200" height="200" />
    </svg>
  );
}
